import Axios from 'axios'
import Store from '@/store'
import Md5 from 'js-md5'
import { baseURL } from '@/api/IPconfig'

import { Message } from 'element-ui'


// 带cookie请求
// Axios.defaults.withCredentials = true

// 设置超时时间
Axios.defaults.timeout = 60000



// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
	// 在发送请求之前做些什么
	//下载文件，回显图片/文件时需将文件流转为blob格式
	if (config.url.indexOf("/kim-staff/file/download") != -1) {
		config.responseType = "blob";
	}
	
	if (config.url.indexOf("/fs/rtf/get") != -1 && config.params.fileId.indexOf("docx") != -1 ) {
		config.responseType = "blob";
	}
	return config;
}, function (error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});


function fnAjax(url,params={},method='',flag) {

    return new Promise((resolve, reject) => {
		let obj = {
			"Content-Type": "application/json",
			// 'sysType': 'WEBSIT', // KL_OS 运营系统    KL_STAFF
			'actNo': Store.getters.userInfo.actNo, // 用户编号
			'uuid': Store.getters.token.uuid
		};
		if(!obj.actNo)  delete obj.actNo;
		if(!obj.uuid)  delete obj.uuid;
		
		if(method=='get') { // md5(requesturl+token.value)
			let ret = '/api'+url+'?';
			for (let it in params) {
				ret += encodeURIComponent(it) + '=' + encodeURIComponent(params[it]) + '&'
			}
			// obj.digest = Md5(ret.slice(0,ret.length-1)+Store.getters.token.tokenValue);
			
		}else{ // md5(requestbody+token.value)
			let objs = {data: params};
			// obj.digest = Md5(JSON.stringify(objs)+Store.getters.token.tokenValue);
		}
		let objs = {
			baseURL: baseURL.seeHouseClientService,
            method,
            url: url,
            data: params,
            headers: obj,
        }
		if(method=='get') {
			objs.params = params;
		}else{
			objs.data = {data: params};
		}
		
        Axios(objs).then(response => {
            resolve(response)
		}).catch(error => { // error.response.status
			let errmsg = (error.response.data&&error.response.data.msg)?error.response.data.msg:error;
			Message({
				message: errmsg,
				type: 'error'
			});
			// reject(error)
        })
    })
}
function get (url, params={},flag=false) {
	return fnAjax(url, params, 'get',flag);
}
function post (url, params={},flag=false) {
	return fnAjax(url, params, 'post',flag);
}

export default {
	get, post,
}



